import { render, staticRenderFns } from "./showCalendarInfo.vue?vue&type=template&id=0a2957d0&scoped=true&"
import script from "./showCalendarInfo.vue?vue&type=script&lang=js&"
export * from "./showCalendarInfo.vue?vue&type=script&lang=js&"
import style0 from "./showCalendarInfo.vue?vue&type=style&index=0&id=0a2957d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2957d0",
  null
  
)

export default component.exports